export default {
  serial: "",
  brand: "",
  deploymentNeeds: "",
  description: "",
  currentFirmware: "",
  model: "",
  owner: "",
  publicInterface: {
    adminTcpPort: 80,
    adminSslPort: 80,
    adminTls: true,
    adminUrl: "",
    ip: "",
    streamTcpUrl: "",
    videoStreamPort: 80,
    protocol: "rtsp",
    secondCoachUrl: "",
    ptzControllerPort: Number(),
  },
  privateInterface: {
    ip: "",
    adminTcpPort: 80,
    videoStreamTcpPort: 80,
  },
  type: "camera",
  use: "fixed",
  users: {
    admin: {
      user: "",
      pass: "",
    },
    viewer: {
      user: "",
      pass: "",
    },
  },
  ownedByPartnerId: null,
  usuallyDisconnected: false,
};
